import React from 'react';
import { Modal } from 'antd';
import * as components from 'libs/components';

const WithComPopup = (props:any) => {
    const getPopup = () => {
        const params = {pgmPath: props.popupId, props: { ...props.props, accept, cancel } };
        return components.fn_getComponent(params);
    }

    const accept = (data:any) => {
        if (props.accept && typeof props.accept === 'function') {
            props.accept(data);
        }
    }

    const cancel = () => {
        if (props.cancel && typeof props.cancel === 'function') {
            props.cancel();
        }
    }

    const [contentLoaded, setContentLoaded] = React.useState(false);

    React.useEffect(() => {
        const timer = setTimeout(() => setContentLoaded(true), 50);
        return () => clearTimeout(timer);
    }, []);

    const width = React.useCallback(() => {
        let result = '';

        if (props.width) {
            result = props.width;
        }

        return result;
    }, [props, props]);

	return (
		<Modal
			key={props.popupId}
            width={width()}
            styles={{
              body:{
                height: contentLoaded ? 'auto' : '300px',
                width : 'auto',
                transition: 'all 0.3s ease-in-out' 
              }
            }}
            centered
			closable={props.isNotClose ? false : props.title ? true : false}
			title={props.title}
			onCancel={props.cancel}
			maskClosable={false}
			visible={true}
			footer={null}
		>
			{getPopup()}
		</Modal>
	);
}

export default WithComPopup;
